import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { config } from "../../../../config/envs";
import { generateTraceId } from "../../../helpers";
import useFeatureFlag from "../../../hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "../../../constants/FeatureFlag";
import { CourtesySubscriptionsAPI } from "../../../api/payments/courtesySubscriptions/api";
import { toCourtesyJusSubInterval } from "../../../constants/courtesy";

const toCourtesyDays = data => {
  if (data.activeDays) {
    return data.activeDays;
  }
  if (data.activeMonths) {
    return data.activeMonths * 30;
  }
  return undefined;
};

export function useFinanceiroCourtesySubmit(clienteId) {
  const canAccess = useFeatureFlag(FEATURE_FLAGS.KILL_SWITCH.ADMIN_PAYMENTS_ARCH_V2);

  const createCourtesyJusSub = data =>
    CourtesySubscriptionsAPI.createForExistingClient(clienteId, {
      provider: "jussub",
      planId: data.planId,
      courtesyDays: toCourtesyJusSubInterval(toCourtesyDays(data)),
      courtesyReason: data.ReleaseCategory
    });

  const createCourtesyJusbill = data => {
    const payload = {
      provider: "jusbill",
      ReleaseCategory: data.ReleaseCategory,
      transactionId: uuidv4()
    };
    if (data.activeMonths) {
      payload.activeMonths = data.activeMonths;
    }
    if (data.activeDays) {
      payload.activeDays = data.activeDays;
    }
    if (data.planId) {
      payload.planId = data.planId;
    }

    return axios.post(
      config.app.adminBaseUrl + `/courtesy-subscriptions/clients/${clienteId}`,
      payload,
      { headers: { "x-trace-id": generateTraceId() } }
    );
  };

  const createCourtesy = data =>
    canAccess.isFeatureFlagEnable
      ? createCourtesyJusSub(data)
      : createCourtesyJusbill(data);

  return { createCourtesy, useJusSub: canAccess.isFeatureFlagEnable };
}
